import React, { useState } from "react";
import { endPoints } from "../../constant/Environment";
import { addData } from "../../Utility/API";
import { Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Switch from "@mui/material/Switch";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

const CreateHappyHour = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [multiplier, setMultiplier] = useState("");
  const [startTime, setStartTime] = useState("");
  const [durationMinutes, setDurationMinutes] = useState("");
  const [coinMultiplier, setCoinMultiplier] = useState("");
  const [streakMultiplier, setStreakMultiplier] = useState("");
  const [bonusDropGc, setBonusDropGc] = useState("");
  const [bonusDropSc, setBonusDropSc] = useState("");
  const [teaserLeadMinutes, setTeaserLeadMinutes] = useState("");
  const [recapWindowMinutes, setRecapWindowMinutes] = useState("");
  const [specifications, setSpecifications] = useState("");
  const [termsAndConditions, setTermsAndConditions] = useState("");
  const [excludePlayer, setExcludePlayer] = useState("");
  const [isActive, setIsActive] = useState(false);

  React.useEffect(() => {
    if (open) {
      if (Object.keys(editData).length === 0) {
        // New record - clear all fields
        setTitle("");
        setMultiplier("");
        setStartTime("");
        setDurationMinutes("");
        setCoinMultiplier("");
        setStreakMultiplier("");
        setBonusDropGc("");
        setBonusDropSc("");
        setTeaserLeadMinutes("");
        setRecapWindowMinutes("");
        setSpecifications("");
        setTermsAndConditions("");
        setExcludePlayer("");
        setIsActive(false);
      } else {
        // Edit record - populate fields
        setTitle(editData?.title || "");
        setMultiplier(editData?.multiplier ?? "");
        // backend stores "HH:mm" or "HH:mm:ss"; trim to HH:mm for the time input
        setStartTime(
          editData?.startTime ? editData.startTime.substring(0, 5) : ""
        );
        setDurationMinutes(editData?.durationMinutes ?? "");
        setCoinMultiplier(editData?.coinMultiplier ?? "");
        setStreakMultiplier(editData?.streakMultiplier ?? "");
        setBonusDropGc(editData?.bonusDropGc ?? "");
        setBonusDropSc(editData?.bonusDropSc ?? "");
        setTeaserLeadMinutes(editData?.teaserLeadMinutes ?? "");
        setRecapWindowMinutes(editData?.recapWindowMinutes ?? "");
        setSpecifications(editData?.specifications || "");
        setTermsAndConditions(editData?.termsAndConditions || "");
        setExcludePlayer(
          Array.isArray(editData?.exclude_player)
            ? editData.exclude_player.join(",")
            : ""
        );
        setIsActive(editData?.isActive === 1);
      }
    }
  }, [editData, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    if (!title || !startTime || !durationMinutes) {
      ErrorToast("Title, Start Time and Duration are required");
      return;
    }

    let url = editData?.id
      ? `${endPoints.api.UPDATE_HAPPYHOUR}`
      : `${endPoints.api.CREATE_HAPPYHOUR}`;

    const excludeList = excludePlayer
      .split(",")
      .map((p) => p.trim())
      .filter((p) => p !== "")
      .map((p) => parseInt(p, 10))
      .filter((p) => !isNaN(p));

    let payload = {
      title: title,
      multiplier: multiplier !== "" ? parseInt(multiplier, 10) : null,
      startTime: startTime,
      durationMinutes:
        durationMinutes !== "" ? parseInt(durationMinutes, 10) : null,
      coinMultiplier:
        coinMultiplier !== "" ? parseInt(coinMultiplier, 10) : null,
      streakMultiplier:
        streakMultiplier !== "" ? parseInt(streakMultiplier, 10) : null,
      bonusDropGc: bonusDropGc !== "" ? parseInt(bonusDropGc, 10) : null,
      bonusDropSc: bonusDropSc !== "" ? parseFloat(bonusDropSc) : null,
      teaserLeadMinutes:
        teaserLeadMinutes !== "" ? parseInt(teaserLeadMinutes, 10) : null,
      recapWindowMinutes:
        recapWindowMinutes !== "" ? parseInt(recapWindowMinutes, 10) : null,
      specifications: specifications,
      termsAndConditions: termsAndConditions,
      exclude_player: excludeList,
      isActive: isActive ? 1 : 0,
    };

    if (editData?.id) {
      payload.id = editData.id;
    }

    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          SuccesToast(response?.data?.message);
          onClose();
        } else {
          ErrorToast(response?.data?.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast(error);
      });
  };

  return (
    <Dialog maxWidth="sm" open={open} {...other}>
      <DialogTitle>Happy Hour Info</DialogTitle>
      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Title"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Time (America/New_York)</label>
          <TextField
            variant="outlined"
            type="time"
            value={startTime}
            onChange={(event) => setStartTime(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Duration (minutes)"
            type="number"
            value={durationMinutes}
            onChange={(event) => setDurationMinutes(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Multiplier (display)"
            type="number"
            value={multiplier}
            onChange={(event) => setMultiplier(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Coin Multiplier"
            type="number"
            value={coinMultiplier}
            onChange={(event) => setCoinMultiplier(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Streak Multiplier"
            type="number"
            value={streakMultiplier}
            onChange={(event) => setStreakMultiplier(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Bonus Drop GC"
            type="number"
            value={bonusDropGc}
            onChange={(event) => setBonusDropGc(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Bonus Drop SC"
            type="number"
            value={bonusDropSc}
            onChange={(event) => setBonusDropSc(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Teaser Lead (minutes)"
            type="number"
            value={teaserLeadMinutes}
            onChange={(event) => setTeaserLeadMinutes(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Recap Window (minutes)"
            type="number"
            value={recapWindowMinutes}
            onChange={(event) => setRecapWindowMinutes(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Specifications"
            multiline
            rows={2}
            value={specifications}
            onChange={(event) => setSpecifications(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Terms And Conditions"
            multiline
            rows={2}
            value={termsAndConditions}
            onChange={(event) => setTermsAndConditions(event.target.value)}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            variant="outlined"
            label="Exclude Player Types (comma separated)"
            value={excludePlayer}
            onChange={(event) => setExcludePlayer(event.target.value)}
          />
        </FormControl>

        <FormControlLabel
          control={
            <Switch
              name="active"
              checked={isActive}
              onClick={() => setIsActive(!isActive)}
            />
          }
          labelPlacement="start"
          label="Active"
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateHappyHour;
